import { UserDataUpload } from '@codefluegel/wowis-rest-typescript-client';
import { Box, Checkbox, Modal, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { useKundenApi, useWelcomeApi } from '../../ApiClient';
import Config from '../../config';
import { useStore } from '../../store/context';
import ThemedButton from '../button/ThemedButton';
import PasswordModal from '../dialog/PasswordModal';
import LoadingSpinner from '../spinner/LoadingSpinner';

const OnlineBillingCard = observer(
  ({
    onlineBilling,
  }: {
    onlineBilling: boolean | null | undefined;
  }): JSX.Element => {
    const { welcomeStore } = useStore();
    const welcomeApi = useWelcomeApi();
    const configuration = Config[process.env.REACT_APP_CLIENT || 'wbg'];

    const kundeApi = useKundenApi();
    // modal state
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    // data changed state

    const [termsAgreed, setTermsAgreed] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);
    const [showPassowrodDialog, setShowPassowrodDialog] = useState(false);

    const handleClose = () => {
      setOpen(false);

      setTermsAgreed(false);
    };

    const handleSave = async () => {
      try {
        setLoading(true);
        const updateData: UserDataUpload = {
          onlineBilling: !onlineBilling,
        };
        const res = await kundeApi.patchKunde(updateData);

        if (res.status === 200) {
          const { data } = await welcomeApi.getWelcomeData(
            welcomeStore.currentEstateId,
          );
          welcomeStore.setWelcomeData(data);

          setLoading(false);
          handleClose();
        }
      } catch (error) {
        console.log(error);
        setErrorMsg('Fehler beim Speichern der Daten');
      }
    };

    const handleButtonClick = () => {
      setOpen(true);
    };

    // error handling
    if (errorMsg) return <Typography color="secondary">{errorMsg}</Typography>;

    // loading
    if (loading) return <LoadingSpinner label="Daten werden gespeichert" />;

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '1rem',
        }}
      >
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',

              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              color="secondary"
            >
              Einverständniserklärung zum Verzicht der Zusendung künftiger
              Vorschreibungen und Jahresabrechnungen in Papierform
            </Typography>
            <Box
              sx={{
                display: 'flex',
                marginTop: 2,
                marginBottom: 2,
              }}
              flexDirection="row"
            >
              <Checkbox
                id="terms-agreed-checkbox"
                sx={{
                  height: 40,
                  marginRight: 1,
                }}
                checked={termsAgreed || false}
                color="primary"
                onChange={e => {
                  setTermsAgreed(e.target.checked);
                }}
              />
              <label
                htmlFor="terms-agreed-checkbox"
                style={{
                  cursor: 'pointer',
                }}
              >
                {!onlineBilling ? (
                  <Typography variant="body2" color="secondary">
                    Ich (Wir) nehme(n) zur Kenntnis, dass künftig Dokumente
                    seitens der {configuration.name} <b>nicht mehr per Post</b>{' '}
                    an mich (uns) gesendet werden, sondern{' '}
                    <b>ausschließlich per Internet</b> zur Verfügung gestellt
                    werden. Die Information über neue Inhalte wird an die von
                    mir (uns) im Datenblatt angegbene Email-Adresse gesendet.
                    <br />
                    <Typography variant="caption" color="secondary">
                      {`(Sie können Ihre persönlichen Daten im Menüpunkt "Meine Daten" jederzeit ändern und
                      eine Weiterleitungs-Email-Adresse eingeben.)`}
                    </Typography>
                  </Typography>
                ) : (
                  <Typography variant="body1" color="secondary">
                    Ich widerrufe hiermit meine Einverständniserklärung, dass
                    künftig Dokumente seitens der {configuration.name} nicht
                    mehr per Post an mich gesendet werden, sondern
                    ausschließlich per Internet zur Verfügung gestellt werden.
                  </Typography>
                )}
              </label>
            </Box>
            <ThemedButton
              label="Speichern"
              onClick={() => setShowPassowrodDialog(true)}
              disabled={!termsAgreed}
            />
          </Box>
        </Modal>

        <Box width={1} px={5} py={3} height={1}>
          {onlineBilling ? (
            <Typography align="center" color="secondary">
              Sie sind Online Kunde
              <br /> Vielen Dank dass Sie sich bereits für die Onlinezustellung
              entschieden haben.{' '}
              {configuration.hasReservations &&
                'Als Onlinekunde mit einem Abbuchungsauftrag erhalten Sie ab dem Rechnungsjahr 2008 jährlich bei der Jahresabrechnung € 5,-- an Verwaltungskosten gut geschrieben.'}{' '}
            </Typography>
          ) : (
            <Typography align="center" color="secondary">
              Sie sind noch kein Online Kunde?{' '}
              {configuration.hasReservations
                ? 'Alle Kunden mit Online-Zustellung der Jahres-abrechnung und einem Abbuchungsauftrag bekommen ab dem Rechnungsjahr 2008 jährlich bei der Jahresabrechnung €5,- an Verwaltungs-kosten gut geschrieben.'
                : 'Jetzt anmelden!'}
            </Typography>
          )}
        </Box>
        <Box sx={{ width: 200 }}>
          <ThemedButton label="Ändern" onClick={handleButtonClick} />
        </Box>
        <PasswordModal
          open={showPassowrodDialog}
          onClose={() => setShowPassowrodDialog(false)}
          onPasswordPassed={handleSave}
        />
      </Box>
    );
  },
);

export default OnlineBillingCard;
